/**
 * LoadingSkeleton for the Financial Affidavit (DRFA) page.
 * Matches the dashboard aesthetic via design tokens.
 */

import React from 'react';
import styles from './drfa-sheet-skeleton.module.css';

const Shim = ({ width = '100%', height = '20px', className = '', style }) => (
  <div
    className={`${styles.shimmer} ${className}`}
    style={{ width, height, ...style }}
  />
);

const ShimLine = ({ width = '100%' }) => (
  <div className={styles.shimmerLine} style={{ width }} />
);

export default function LoadingSkeleton() {
  return (
    <div className={styles.page}>
      <div className={styles.wrapper}>
        {/* Header card */}
        <div className={styles.headerCard}>
          <Shim
            width="60%"
            height="32px"
            className={styles.headerTitleShim}
          />
          <Shim
            width="40%"
            height="20px"
            className={styles.headerSubtitleShim}
          />

          <div className={styles.headerMeta}>
            <Shim width="120px" height="24px" />
            <div className={styles.headerMetaGroup}>
              <Shim width="150px" height="16px" />
              <Shim width="150px" height="16px" />
              <Shim width="120px" height="16px" />
            </div>
            <Shim width="100px" height="32px" />
          </div>
        </div>

        {/* Main form card (tabs + content) */}
        <div className={styles.formCard}>
          <div className={styles.tabStrip}>
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className={styles.tabShim}>
                <Shim width="80px" height="16px" />
              </div>
            ))}
          </div>

          <div className={styles.formBody}>
            <Shim
              width="300px"
              height="28px"
              className={styles.contentHeading}
            />

            {[1, 2, 3].map((i) => (
              <div key={i} className={styles.contentBlock}>
                <Shim
                  width="200px"
                  height="20px"
                  className={styles.contentBlockHeading}
                />
                <div className={styles.contentGrid}>
                  <div>
                    <ShimLine width="60%" />
                    <ShimLine width="80%" />
                    <ShimLine width="40%" />
                  </div>
                  <div>
                    <ShimLine width="70%" />
                    <ShimLine width="90%" />
                    <ShimLine width="50%" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Summary card */}
        <div className={styles.summaryCard}>
          <Shim
            width="200px"
            height="24px"
            className={styles.summaryHeading}
          />

          <div className={styles.summaryGrid}>
            {[1, 2, 3].map((i) => (
              <div key={i} className={styles.summaryItem}>
                <Shim width="60px" height="12px" />
                <Shim width="80px" height="24px" />
                <Shim width="40px" height="12px" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
